import { render, staticRenderFns } from "./StatChart.vue?vue&type=template&id=5b6eda6a&"
import script from "./StatChart.vue?vue&type=script&lang=ts&"
export * from "./StatChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports